import React from 'react';
import { Layer } from 'react-konva';

import Warp from './warpContainer';

type Props = {
    documentIds: string[];
    selectedDocumentId?: string;
    scale: number;
    cursorChange: (cursor: string) => void;
    offset: { x: number; y: number };
    container: HTMLElement;
};

const Warps: React.FC<Props> = ({ scale, offset, cursorChange, container, documentIds, selectedDocumentId }) => {
    return (
        <Layer>
            {documentIds.map((id) => (
                <Warp
                    key={id}
                    documentId={id}
                    selected={selectedDocumentId === id}
                    container={container}
                    cursorChange={cursorChange}
                    scale={scale}
                    offset={offset}
                />
            ))}
        </Layer>
    );
};

export default React.memo(Warps);
